(() => {
  const app = document.getElementById('pp-tracking-page-app');
  const fallback = document.querySelector('[data-tracking-fallback]');
  if (!app || !fallback || app.dataset.trackingInitialized) return;
  app.dataset.trackingInitialized = 'true';

  const input = fallback.querySelector('input[name="nums"]');
  const number = new URLSearchParams(window.location.search).get('nums');
  if (input && number) input.value = number;

  let timeout;
  const ready = () => {
    if (!app.querySelector('form,input,button,.pp_tracking_result')) return false;
    fallback.hidden = true;
    clearTimeout(timeout);
    return true;
  };
  const observer = new MutationObserver(() => {
    if (ready()) observer.disconnect();
  });
  observer.observe(app, {childList: true, subtree: true});
  if (ready()) {
    observer.disconnect();
    return;
  }

  const showAlternative = () => {
    if (ready()) return;
    const status = fallback.querySelector('[data-tracking-status]');
    status.textContent = 'Use the form above to view your shipment updates.';
    status.hidden = false;
  };
  // The customer form is already usable. A slow vendor must not block it.
  timeout = setTimeout(showAlternative, 12000);
  const script = document.createElement('script');
  script.src = app.dataset.trackingScript;
  script.async = true;
  script.addEventListener('error', showAlternative, {once: true});
  document.head.appendChild(script);
})();
